export const getSafeRedirectUrl = (target, baseOrigin = window.location.origin) => {
    if (!target) {
        return null;
    }
    try {
        const normalizedUrl = new URL(target, baseOrigin);
        if (normalizedUrl.origin !== baseOrigin) {
            return null;
        }
        return normalizedUrl.href;
    }
    catch {
        return null;
    }
};
